import * as Sentry from '@sentry/browser';
import { commonSentryConfig } from './common-sentry-config';
import { persistJourneyBreadcrumb } from './journey-breadcrumbs';

Sentry.init({
  ...commonSentryConfig,
  tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE),
  tracePropagationTargets: ['www.analytehealth.local', 'analytehealth.com'],
  integrations: [Sentry.browserTracingIntegration()],
  beforeBreadcrumb(breadcrumb) {
    persistJourneyBreadcrumb(breadcrumb);

    return breadcrumb;
  },
});
